export default "__VITE_ASSET__CIQJ0WjZ__"